import React from 'react';
import styled from 'styled-components';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import PropTypes from 'prop-types';

Icon.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	src: PropTypes.string,
	iconFunction: PropTypes.func,
	fill: PropTypes.string,
	size: PropTypes.string,
	stroke: PropTypes.string,
	strokeWidth: PropTypes.string
};

Icon.defaultProps = {
	fill: 'none'
};

export default function Icon(props) {
	const {title, styleName, className, src, iconFunction, fill, size, stroke, strokeWidth, ...rest} = props;

	return (
		<StyledMotifIcon
			className={className || styleName}
			src={src}
			iconFunction={iconFunction}
			fill={fill}
			size={size}
			stroke={stroke}
			strokeWidth={strokeWidth}
			title={title}
			{...rest}
		/>
	);
}

const StyledMotifIcon = styled(MotifIcon)`
	svg {
		path {
			fill: currentColor;
		}
	}
`;
